import { inject } from '@angular/core';
import { TagsService } from '@core/services';
import { Pagination, TagEntity, TagsListEntity } from '@core/entities';
import { FilterQuery } from '@core/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { TagType } from '@core/enums';

export class UseTag {
  private readonly _tagsService = inject(TagsService);

  createTag(tagName: string, type: string): Observable<boolean> {
    return this._tagsService.create({ tag_name: tagName, type: type }).pipe(
      map((response) => {
        if (response) {
          return true;
        }
        return false;
      }),
    );
  }

  updateTag(tag: TagEntity): Observable<boolean> {
    return this._tagsService.update(tag.id, { tag_name: tag.tagName }).pipe(
      map((response) => {
        if (response) {
          return true;
        }
        return false;
      }),
    );
  }

  deleteTag(id: number): Observable<boolean> {
    return this._tagsService.delete(id).pipe(
      map((response) => {
        if (response) {
          return true;
        }
        return false;
      }),
    );
  }

  getAllAvailableTags(pagination: Partial<Pagination>, type: TagType, search?: string): Observable<TagsListEntity> {
    const queryParam: FilterQuery = {
      type: type,
      search,
    };
    return this._tagsService.find(pagination, queryParam).pipe(
      map((response) => {
        if (response) {
          return {
            pagination: response.pagination,
            tags: response.tags.map((item: any) => {
              return plainToClass(TagEntity, item as TagEntity);
            }),
          } as TagsListEntity;
        }
        return null;
      }),
    );
  }

  getAllTagsByType(type: TagType): Observable<TagEntity[]> {
    const queryParam: FilterQuery = {
      type: type,
    };
    return this._tagsService.find(null, queryParam).pipe(
      map((response) => {
        if (response) {
          return response.map((item: any) => {
            return plainToClass(TagEntity, item as TagEntity);
          });
        }
        return null;
      }),
    );
  }
}
